import React from 'react';

const Header = (props) => {
    return (
        <header className="py-3 py-md-4 bg-info text-white text-center">
            <div className="container py-3 py-md-4">
                <h1><strong>{new Date().getFullYear()} {props.title}</strong></h1>
            </div>
        </header>
    );
} 

export default Header;